export const getExportTypes = t => {
  let exportTypes = [
    { value: 'simple', label: t('Simple') },
    { value: 'detailed', label: t('Detallada') },
  ]

  return exportTypes
}
